import React, { useContext, useMemo, useState } from 'react';
import HeaderPreview from "../../../GeneratePdf/HeaderPreview";
import FooterPreview from "../../../GeneratePdf/FooterPreview";
import { initialData } from '../groupReport-pdf/QuadrantInFocus';
import GroupReportContext from '../../../../Context/GroupReportContext';
import { useGroupReportDate } from '../../../../Context/GroupReportDate';

const SoulPreview360 = ({ apiData, reportType, pageNumber }) => {

  const questions = [
    {
      id: 1,
      question: "[First Name]'s superpower is to rise above any situation to gain a wise perspective.",
      quadrant: 'SOUL',
    },
    {
      id: 2,
      question: '[First Name] evaluates decisions by their ability to fulfill the greater vision.',
      quadrant: 'SOUL',
    },
    {
      id: 3,
      question: '[First Name] is most fulfilled when living out a greater purpose.',
      quadrant: 'SOUL',
    },
    {
      id: 4,
      question: '[First Name] is motivated by opportunities that develop depth of character.',
      quadrant: 'SOUL',
    },
    {
      id: 5,
      question: '[First Name] relies heavily on the meaning of their story when working on a project.',
      quadrant: 'SOUL',
    },
    {
      id: 6,
      question: '[First Name] believes their work should connect to a larger purpose.',
      quadrant: 'SOUL',
    },
    {
      id: 7,
      question: '[First Name] is always searching for the reasons “why” they are doing something.',
      quadrant: 'SOUL',
    },
    {
      id: 8,
      question: '[First Name] struggles to stay engaged when the work has no clear purpose.',
      quadrant: 'SOUL',
    },
    {
      id: 9,
      question: '[First Name] is drawn to people who are visionaries.',
      quadrant: 'SOUL',
    },
    {
      id: 10,
      question: "[First Name] finds satisfaction in sharing meaningful stories that impact people's lives.",
      quadrant: 'SOUL',
    },
  ];


  const respondentName = apiData?.fullName?.split(' ')[0] || '[First Name]';
  const groupReportCtx = useContext(GroupReportContext);
  const {tablevaluesq2: tablevaluesq2Raw} = useGroupReportDate();

  // Merge all page data into a single array
  const tablevaluesq2 = useMemo(() => {
    if (!tablevaluesq2Raw) return [];

    const mergedData = [];
    // Merge data from all pages (page1, page2, page3, page4)
    ['page1', 'page2', 'page3', 'page4'].forEach(pageKey => {
      if (tablevaluesq2Raw[pageKey] && Array.isArray(tablevaluesq2Raw[pageKey])) {
        mergedData.push(...tablevaluesq2Raw[pageKey]);
      }
    });

    return mergedData;
  }, [tablevaluesq2Raw]);

  const [dynamicData, setDynamicData] = useState([...initialData]);

  const displayData = dynamicData;
  const allMembersDataArray = Object.values(apiData?.memberResults?.allMembersData || {});
  const allVariableSets = allMembersDataArray.map(el => el.variables);


  const styles = {
    container: { paddingTop: '16px' },
    heading: { fontSize: "14px", paddingBottom: "16px", lineHeight: "18px", fontWeight: 700, color: "#426B88", margin: 0, fontFamily: "'Helvetica', sans-serif", letterSpacing: 0 },
    description: { marginBottom: "16px", color: "#245775", marginTop: 0, fontFamily: "'Helvetica', sans-serif", fontWeight: 400, fontStyle: 'normal', fontSize: '12px', lineHeight: '18px', letterSpacing: '0px' },
    tableWrapper: { overflow: "hidden", border: "0.25px solid #0000001A", borderRadius: "16px" },
    table: { width: "100%", borderCollapse: "separate", borderSpacing: "0", lineHeight:"13px",  },
    th: { padding: "0 12px", backgroundColor: "#245775", color: "white", textAlign: "center", fontFamily: 'Helvetica', fontWeight: 400, lineHeight:"13px", fontStyle: 'normal', fontSize: '9px', letterSpacing: '0px' },
    td: { borderLeft: "0.67px solid #ddd", padding: "5px", textAlign: "center", fontFamily: 'Helvetica', fontWeight: 400, fontStyle: 'normal', fontSize: '9px', letterSpacing: '0px', color: "#000000" },     soulColumn: { width: "100%", textAlign: "left", padding: "5.5px 15px", border: "none" },
    rowEven: { backgroundColor: "#FFF" },
    rowOdd: { backgroundColor: "#F1F3F3" },
    rectangleWrapper: { display: "flex", justifyContent: "center", alignItems: "center", height: "26px", width: "25px", margin: "0 auto" },
    rectangle: { width: "16px", height: "16px", backgroundColor: "#00577D", borderRadius: "1.34px" }
  };


  const renderRectangle = (avgScore, index) => {
    const full = Math.floor(avgScore);
    const partial = avgScore - full;
    if (index < full) {
      // Full blue square
      return <div style={styles.rectangle}></div>;
    } else if (index === full && partial > 0) {
      // Partial blue square (only blue part, no light background)
      return (
        <div style={{ ...styles.rectangle, position: 'relative', overflow: 'hidden', backgroundColor: 'transparent' }}>
          <div style={{
            position: 'absolute',
            left: 0,
            top: 0,
            width: `${partial * 100}%`,
            height: '100%',
            backgroundColor: '#00577D',
            borderRadius: '2px',
            zIndex: 2,
          }}></div>
        </div>
      );
    } else {
      return null;
    }
  };

  const quadrantScores = {
    "HEART": 1,
    "SOUL": 2,
    "MIND": 3,
    "STRENGTH": 4
  }
  const allResults = [];
  displayData?.forEach((el, index) => {
    // Only process SOUL quadrant items (quadrant score 2)
    if (quadrantScores?.[el.quadrant] === 2 && tablevaluesq2[index]) {
      // Get the last value from the array (index 5) which is the average score
      const averageScore = tablevaluesq2[index]?.[5];
      allResults.push({
        averageScore: averageScore,
        quadrant: el.quadrant,
        no: el.no,
        ques: el?.question
      });
    }
  });

  // console.log("allResults", allResults)


  return (
    <div style={{ backgroundColor: "rgb(255, 255, 255)" }}>
      <HeaderPreview />
      <div className="three60-focus-container">
        <h1 className="three60-focus-heading">SOUL 360 IN FOCUS</h1>
        <p className="three60-focus-description">
          This chart isolates the items related to the Soul based on the OBSERVER ratings (SELF excluded). Focused results reflect the average of observer scores only. The response scale runs from 1 (Least) to 4 (Most). Any unselected statement will appear blank in the In Focus section.
        </p>

        <div className="three60-focus-table-wrapper">
          <table className="three60-focus-table">
            <thead className="three60-focus-table-header">
              <tr>
                <th className="three60-focus-th three60-focus-heart-column">Soul</th>
                <th style={{ ...styles.th, ...styles.soulColumn }}>Score</th>
                {[1, 2, 3, 4].map((num) => (
                  <th key={num} className="three60-focus-th">{num}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {questions.map((item, index) => {
                const avgScore = allResults[index]?.averageScore;
                return (
                  <tr key={index} className={index % 2 === 0 ? "three60-focus-row-even" : "three60-focus-row-odd"}>
                    <td
                      className="three60-focus-td three60-focus-heart-column"
                      title={item.question.replace(/\[First Name\]/g, respondentName)}
                    >
                      {item.question.replace(/\[First Name\]/g, respondentName)}
                    </td>
                    <td style={{ ...styles.td }}>{parseFloat(avgScore) > 0 ? avgScore : "-"}</td>
                    {[0, 1, 2, 3].map((idx) => (
                      <td key={idx} style={styles.td}>
                        <div style={styles.rectangleWrapper}>
                          {renderRectangle(avgScore, idx)}
                        </div>
                      </td>
                    ))}
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </div>
      <FooterPreview pageNumber={pageNumber} reportType={reportType} />
    </div>
  );
};

export default SoulPreview360;
